import CheckCircleOutlineIcon from '@atlaskit/icon/glyph/check-circle-outline';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { usePrivacySecurityAnalytics } from '@atlassian/mpac-analytics';
import { LinkWithIcon } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { ANALYTICS_EVENT_CONTAINER_OVERVIEW_TAB, ANALYTICS_OVERVIEW_BUG_BOUNTY_LEARN_MORE_UI_LINK } from '../../constants';
import { InfoListItem, InfoListItemContent, InfoListItemIcon, ItemDescription } from '../styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BugBountyProgram = props => {
  const {
    hosting,
    bugBountyParticipant
  } = props;
  const participatesInBugBounty = isBugBountyParticipant(hosting, bugBountyParticipant);
  const {
    fireLinkEvent
  } = usePrivacySecurityAnalytics();
  const learnMoreLinkText = 'Learn more';
  const onLearnMoreLinkClick = () => {
    fireLinkEvent(ANALYTICS_OVERVIEW_BUG_BOUNTY_LEARN_MORE_UI_LINK, {
      source: ANALYTICS_EVENT_CONTAINER_OVERVIEW_TAB,
      isBugBountyParticipant: participatesInBugBounty,
      linkText: learnMoreLinkText
    });
  };
  return /*#__PURE__*/_jsxs(InfoListItem, {
    children: [/*#__PURE__*/_jsx(InfoListItemIcon, {
      children: participatesInBugBounty ? /*#__PURE__*/_jsx(CheckCircleOutlineIcon, {
        label: "",
        size: "medium"
      }) : /*#__PURE__*/_jsx(CrossIcon, {
        label: "",
        size: "medium"
      })
    }), /*#__PURE__*/_jsxs(InfoListItemContent, {
      children: [/*#__PURE__*/_jsx(ItemDescription, {
        children: participatesInBugBounty ? 'This app is part of the Marketplace Bug Bounty program.' : 'This app is not part of the Marketplace Bug Bounty program.'
      }), participatesInBugBounty && /*#__PURE__*/_jsx(LinkWithIcon, {
        href: "https://developer.atlassian.com/platform/marketplace/marketplace-security-bug-bounty-program/",
        type: "external",
        size: "medium",
        onClick: onLearnMoreLinkClick,
        "aria-label": "Learn more about Marketplace Security Bug Bounty Program",
        children: "About Bug Bounty program"
      })]
    })]
  });
};